module.exports = __webpack_public_path__ + "static/img/invta_iphone.54e4e9f7.png";